import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useEffect, useState } from "react";

import { useShiftModalsDataContext } from "../../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetCardsWrapper } from "../../BottomSheet/CardsWrapper";
import { ShiftFailedLoadingCard } from "../../BottomSheet/ShiftFailedLoadingCard";
import { ShiftDoubleBookingFooter } from "./BookingFooter";
import { ShiftDoubleBottomSheetContent } from "./Content";
import { ShiftDoubleBottomSheetHeader } from "./Header";

export interface ShiftDoubleBottomSheetProps {
  modalState: UseModalState;
}

export function ShiftDoubleBottomSheet(props: ShiftDoubleBottomSheetProps) {
  const { modalState } = props;

  const { shift, double, shiftFailedLoading } = useShiftModalsDataContext();

  const { workplace } = shift ?? {};

  const hasRequiredData = isDefined(double) && isDefined(shift) && isDefined(workplace);

  const [selectedCompanionId, setSelectedCompanionId] = useState(
    double?.companionShifts[0]?.id ?? ""
  );

  // Sync selection when double data arrives or changes
  useEffect(() => {
    const firstCompanionId = double?.companionShifts[0]?.id;
    if (isDefined(firstCompanionId)) {
      setSelectedCompanionId(firstCompanionId);
    }
  }, [double?.companionShifts]);

  // Derive the selected companion and its pay
  const selectedCompanion = double?.companionShifts.find((c) => c.id === selectedCompanionId);
  const selectedCompanionPay = selectedCompanion
    ? double?.companionShiftPays?.get(selectedCompanion.id)
    : undefined;

  return (
    <BottomSheet modalState={modalState}>
      {hasRequiredData && (
        <>
          <ShiftDoubleBottomSheetHeader
            workplaceName={workplace.attributes.name}
            onClose={() => {
              modalState.closeModal();
            }}
          />

          <ShiftDoubleBottomSheetContent
            shift={shift}
            double={double}
            workplaceTimezone={workplace.attributes.location.timezone}
            selectedCompanionId={selectedCompanionId}
            onSelectCompanion={setSelectedCompanionId}
          />

          {isDefined(selectedCompanion) && (
            <ShiftDoubleBookingFooter
              shift={shift}
              double={double}
              selectedCompanion={selectedCompanion}
              selectedCompanionPay={selectedCompanionPay}
              hideTotalPay={double.companionShifts.length > 1}
            />
          )}
        </>
      )}

      {!hasRequiredData && shiftFailedLoading && (
        <ShiftBottomSheetCardsWrapper>
          <ShiftFailedLoadingCard />
        </ShiftBottomSheetCardsWrapper>
      )}
    </BottomSheet>
  );
}
